import { render, staticRenderFns } from "./footview.vue?vue&type=template&id=555aff18&scoped=true&"
import script from "./footview.vue?vue&type=script&lang=js&"
export * from "./footview.vue?vue&type=script&lang=js&"
import style0 from "./footview.vue?vue&type=style&index=0&id=555aff18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555aff18",
  null
  
)

export default component.exports